(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 9208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(940);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./pages/shared/external-link.tsx
var external_link = __webpack_require__(1873);
;// CONCATENATED MODULE: ./pages/index.page/clickable-code.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px dotted transparent;\n  color: inherit;\n  .js & {\n    cursor: pointer;\n    border-bottom-color: rgba(27, 31, 35, 0.3);\n\n    :active {\n      background: rgba(27, 31, 35, 0.3);\n    }\n  }\n\n  @media (prefers-color-scheme: dark) {\n    .js & {\n      border-bottom-color: rgba(127, 127, 127, 0.5);\n\n      .js &:active {\n        background: rgba(127, 127, 127, 0.5);\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const styled = styled_components_browser_esm["default"];
const ClickableCode = styled.code(_templateObject());

;// CONCATENATED MODULE: ./pages/index.page/available-destinations.tsx

function available_destinations_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 0;\n  overflow: hidden;\n"
    ]);
    available_destinations_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  /* transition: color 0.2s ease-in-out; */\n  white-space: nowrap;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: inline-block;\n  :after {\n    display: inline-block;\n    content: "→";\n  }\n'
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  white-space: normal;\n  vertical-align: top;\n  margin-right: 2.5em;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}





const available_destinations_styled = styled_components_browser_esm["default"];
const Ul = available_destinations_styled.ul(available_destinations_templateObject());
const Item = available_destinations_styled.li(_templateObject1(), (props)=>props.highlighted ? "color: #42a73f" : "");
const Keyword = available_destinations_styled(ClickableCode)(_templateObject2());
const Arrow = available_destinations_styled.span(_templateObject3());
const Info = available_destinations_styled.span(_templateObject4());
const AvailableDestinations = (param)=>{
    let { selectedDestination , onSelectedDestinationChange  } = param;
    const handleKeywordClick = react.useCallback((param)=>{
        let { currentTarget  } = param;
        onSelectedDestinationChange(currentTarget.textContent);
    }, [
        onSelectedDestinationChange
    ]);
    // When updating, remember to reflect changes in README.md and cli/cli.js
    const keywordInfos = react.useMemo(()=>[
            {
                keywords: [
                    "b"
                ],
                info: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "package cost estimation on",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                            href: "https://bundlephobia.com"
                        })
                    ]
                })
            },
            {
                keywords: [
                    "c"
                ],
                info: "changelog"
            },
            {
                keywords: [
                    "g"
                ],
                info: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "github (gitlab, etc.) repository root"
                })
            },
            {
                keywords: [
                    "h",
                    "w",
                    "d"
                ],
                info: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "homepage (aliased as",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                            onClick: handleKeywordClick,
                            children: "w"
                        }),
                        " for\xa0website or ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                            onClick: handleKeywordClick,
                            children: "d"
                        }),
                        " for\xa0docs)"
                    ]
                })
            },
            {
                keywords: [
                    "i"
                ],
                info: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "issues"
                })
            },
            {
                keywords: [
                    "n"
                ],
                info: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "package info on ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                            href: "https://www.npmjs.com"
                        })
                    ]
                })
            },
            {
                keywords: [
                    "p",
                    "m"
                ],
                info: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "pull requests (aliased as",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                            onClick: handleKeywordClick,
                            children: "m"
                        }),
                        " for\xa0merge requests)"
                    ]
                })
            },
            {
                keywords: [
                    "r"
                ],
                info: "list of github releases"
            },
            {
                keywords: [
                    "s"
                ],
                info: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "source (often same as repository root, but can be its\xa0subdirectory in\xa0case of a\xa0monorepo)"
                })
            },
            {
                keywords: [
                    "t"
                ],
                info: "list of git tags"
            },
            {
                keywords: [
                    "u"
                ],
                info: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "package contents preview on",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                            href: "https://unpkg.com"
                        })
                    ]
                })
            },
            {
                keywords: [
                    "v"
                ],
                info: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "list of package versions with dates on",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                            href: "https://www.npmjs.com"
                        })
                    ]
                })
            },
            {
                keywords: [
                    "y"
                ],
                info: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "package page on ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                            href: "https://yarnpkg.com"
                        }),
                        " (mirror registry for ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                            href: "https://www.npmjs.com"
                        }),
                        ")"
                    ]
                })
            },
            {
                keywords: [
                    "."
                ],
                info: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "browse GitHub / GitLab code"
                })
            }
        ], [
        handleKeywordClick
    ]);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Ul, {
                children: keywordInfos.map((param, index)=>/*#__PURE__*/ {
                    let { keywords , info  } = param;
                    return (0,jsx_runtime.jsxs)(Item, {
                        highlighted: selectedDestination ? keywords.includes(selectedDestination) : false,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                                onClick: handleKeywordClick,
                                children: (ref = keywords[0]) !== null && ref !== void 0 ? ref : ""
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {}),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {
                                children: info
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Omitting the destination or entering an non-existing one takes you to the package page on ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                        href: "https://www.npmjs.com"
                    }),
                    " as if you used\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                        onClick: handleKeywordClick,
                        children: "n"
                    }),
                    "."
                ]
            })
        ]
    });
};
const WrappedAvailableDestinations = /*#__PURE__*/ react.memo(AvailableDestinations);


;// CONCATENATED MODULE: ./pages/index.page/example.tsx

function example_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n"
    ]);
    example_templateObject = function() {
        return data;
    };
    return data;
}
function example_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    example_templateObject1 = function() {
        return data;
    };
    return data;
}





const example_styled = styled_components_browser_esm["default"];
const Remark = example_styled.span(example_templateObject());
const LinkRow = example_styled.span(example_templateObject1());
const Example = (param)=>{
    let { onToClick , remark , to , url  } = param;
    const handleCodeClick = ()=>{
        onToClick === null || onToClick === void 0 ? void 0 : onToClick(to);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClickableCode, {
                        onClick: handleCodeClick,
                        children: [
                            "njt ",
                            to
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Remark, {
                        children: [
                            "(",
                            remark,
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkRow, {
                children: [
                    "\uD83D\uDC38 → ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                        href: url
                    })
                ]
            })
        ]
    });
};
const WrappedExample = /*#__PURE__*/ react.memo(Example);


;// CONCATENATED MODULE: ./pages/index.page/input-form.tsx

function input_form_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  white-space: nowrap;\n  font-size: 2em;\n  padding: ",
        "px 0 0;\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n  line-height: 1em;\n\n  @media (max-width: 600px) {\n    font-size: 1.8em;\n  }\n  @media (max-width: 550px) {\n    font-size: 1.6em;\n  }\n  @media (max-width: 510px) {\n    font-size: 1.5em;\n  }\n  @media (max-width: 450px) {\n    font-size: 1.4em;\n  }\n  @media (max-width: 420px) {\n    font-size: 1.3em;\n  }\n  @media (max-width: 400px) {\n    font-size: 1.25em;\n  }\n  @media (max-width: 370px) {\n    font-size: 1.1em;\n  }\n  @media (max-width: 350px) {\n    font-size: 1em;\n  }\n"
    ]);
    input_form_templateObject = function() {
        return data;
    };
    return data;
}
function input_form_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.3em 0 0 0.7em;\n  font-family: monospace;\n  display: inline-block;\n  position: absolute;\n  top: ",
        "px;\n  left: 0;\n  pointer-events: none;\n"
    ]);
    input_form_templateObject1 = function() {
        return data;
    };
    return data;
}
function input_form_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  padding: 0.3em 4em 0.3em 3em;\n  color: inherit;\n  line-height: inherit;\n  font-family: monospace;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  border: 1px solid rgba(127, 127, 127, 0.5);\n  border-radius: 5px;\n  -webkit-appearance: none;\n  /* transition: all 0.2s ease-in-out; */\n\n  background: rgba(27, 31, 35, 0.05);\n\n  @media (prefers-color-scheme: dark) {\n    background: rgba(127, 127, 127, 0.3);\n  }\n\n  ::placeholder {\n    color: rgba(127, 127, 127, 0.7);\n  }\n\n  :focus {\n    outline: none !important;\n    border: 1px solid #42a73f;\n    box-shadow: 0 0 10px #7cd679;\n  }\n"
    ]);
    input_form_templateObject2 = function() {
        return data;
    };
    return data;
}
function input_form_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background: transparent;\n  line-height: inherit;\n  padding: 0.25em 0.4em 0.3em 0;\n  cursor: pointer;\n  color: inherit;\n\n  position: absolute;\n  top: ",
        "px;\n  right: 0;\n\n  :active {\n    top: ",
        "px;\n  }\n\n  :focus {\n    outline: none !important;\n  }\n"
    ]);
    input_form_templateObject3 = function() {
        return data;
    };
    return data;
}



const input_form_styled = styled_components_browser_esm["default"];
const verticalFormPadding = 20;
const Form = input_form_styled.form(input_form_templateObject(), verticalFormPadding);
const Label = input_form_styled.label(input_form_templateObject1(), verticalFormPadding + 1);
const Input = input_form_styled.input(input_form_templateObject2());
const SubmitButton = input_form_styled.button(input_form_templateObject3(), verticalFormPadding + 1, verticalFormPadding + 2);
const InputForm = (param)=>{
    let { text , onTextChange  } = param;
    const formRef = react.useRef(null);
    const previousToValue = react.useRef();
    const toInputRef = react.useRef(null);
    const focusAndSelectAll = react.useCallback(()=>{
        const input = toInputRef.current;
        if (input) {
            input.focus({
                preventScroll: true
            });
            input.setSelectionRange(0, input.value.length);
        }
    }, [
        toInputRef
    ]);
    const handleInputChange = react.useCallback((param)=>{
        let { currentTarget: { value  }  } = param;
        previousToValue.current = value;
        onTextChange === null || onTextChange === void 0 ? void 0 : onTextChange(value);
    }, [
        onTextChange
    ]);
    react.useEffect(()=>{
        if (previousToValue.current !== text) {
            focusAndSelectAll();
        }
        if (typeof previousToValue.current === "string" && formRef.current) {
            formRef.current.scrollIntoView({
                block: "nearest",
                inline: "nearest",
                behavior: "smooth"
            });
        }
        previousToValue.current = text;
    }, [
        focusAndSelectAll,
        text,
        previousToValue,
        formRef
    ]);
    const [from, setFrom] = react.useState("noscript");
    const fromInputRef = react.useRef(null);
    react.useEffect(()=>{
        setFrom("bookmark");
    }, []);
    const handleFormSubmit = ()=>{
        if (fromInputRef.current) {
            fromInputRef.current.value = "web";
        }
        return true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
        ref: formRef,
        action: "/jump",
        onSubmitCapture: handleFormSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: fromInputRef,
                type: "hidden",
                name: "from",
                value: from
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                htmlFor: "to",
                children: "njt"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                ref: toInputRef,
                id: "to",
                name: "to",
                placeholder: "<package> [destination]",
                value: text,
                onFocus: focusAndSelectAll,
                onChange: handleInputChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                tabIndex: -1,
                children: "\uD83D\uDC38 →"
            })
        ]
    });
};

// EXTERNAL MODULE: ./pages/shared/page-metadata.tsx
var page_metadata = __webpack_require__(9953);
;// CONCATENATED MODULE: ./pages/index.page.tsx

function index_page_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 3em;\n  font-size: 1em;\n"
    ]);
    index_page_templateObject = function() {
        return data;
    };
    return data;
}
function index_page_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    index_page_templateObject1 = function() {
        return data;
    };
    return data;
}
function index_page_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin-right: 0.5em;\n  cursor: default;\n  ",
        ";\n"
    ]);
    index_page_templateObject2 = function() {
        return data;
    };
    return data;
}








const index_page_styled = styled_components_browser_esm["default"];
const H2 = index_page_styled.h2(index_page_templateObject());
const ExamplePackages = index_page_styled.div(index_page_templateObject1());
const ExamplePackage = index_page_styled.div(index_page_templateObject2(), (props)=>props.clickable ? "\n    border-bottom: 1px dotted #24292e66;\n    cursor: pointer;\n  " : "");
const remarkByDestination = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "": "no specified destination",
    h: "homepage",
    s: "source",
    r: "releases",
    y: "yarn"
};
const exampleUrlByPackageAndDestination = {
    prettier: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "": "https://www.npmjs.com/package/prettier",
        h: "https://prettier.io",
        s: "https://github.com/prettier/prettier",
        r: "https://github.com/prettier/prettier/releases",
        y: "https://yarnpkg.com/package/prettier"
    },
    react: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "": "https://www.npmjs.com/package/react",
        h: "https://reactjs.org",
        s: "https://github.com/facebook/react/tree/main/packages/react",
        r: "https://github.com/facebook/react/releases",
        y: "https://yarnpkg.com/package/react"
    },
    lodash: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "": "https://www.npmjs.com/package/lodash",
        h: "https://lodash.com",
        s: "https://github.com/lodash/lodash",
        r: "https://github.com/lodash/lodash/releases",
        y: "https://yarnpkg.com/package/lodash"
    },
    typescript: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "": "https://www.npmjs.com/package/typescript",
        h: "https://www.typescriptlang.org",
        s: "https://github.com/Microsoft/TypeScript",
        r: "https://github.com/Microsoft/TypeScript/releases",
        y: "https://yarnpkg.com/package/typescript"
    }
};
const Page = ()=>{
    const [examplePackage, setExamplePackage] = react.useState(()=>Object.keys(exampleUrlByPackageAndDestination)[0]);
    const handleExamplePackageClick = react.useCallback((event)=>{
        setExamplePackage(event.currentTarget.textContent);
    }, [
        setExamplePackage
    ]);
    const [inputText, setInputText] = react.useState("");
    const handleExampleClick = react.useCallback((text)=>{
        setInputText(" ");
        setTimeout(()=>{
            setInputText(text);
        }, 0);
    }, [
        setInputText
    ]);
    const handleSelectedDestinationChange = react.useCallback((destination)=>{
        setInputText((currentInputText)=>{
            const currentPackage = currentInputText.trim().split(" ", 1)[0];
            return "".concat(currentPackage || examplePackage, " ").concat(destination);
        });
    }, [
        setInputText,
        examplePackage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(page_metadata/* PageMetadata */.d, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputForm, {
                text: inputText,
                onTextChange: setInputText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                children: "Available destinations"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedAvailableDestinations, {
                selectedDestination: inputText.trim().split(" ", 2)[1],
                onSelectedDestinationChange: handleSelectedDestinationChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                children: "Examples"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamplePackages, {
                children: Object.keys(exampleUrlByPackageAndDestination).map((currentExamplePackage)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ExamplePackage, {
                        clickable: currentExamplePackage !== examplePackage,
                        onClick: handleExamplePackageClick,
                        children: currentExamplePackage
                    }, currentExamplePackage))
            }),
            Object.entries(remarkByDestination).map((param)=>{
                let [destination, remark] = param;
                const destinationLookup = exampleUrlByPackageAndDestination[examplePackage];
                if (!destinationLookup) {
                    return;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedExample, {
                    to: "".concat(examplePackage, " ").concat(destination).trim(),
                    remark: remark,
                    url: destinationLookup[destination],
                    onToClick: handleExampleClick
                }, destination);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                children: "More!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                        children: "njt"
                    }),
                    " gives you an even bigger productivity boost when integrated into browser or\xa0terminal. See instructions in",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                        href: "https://github.com/kachkaev/njt/blob/main/README.md#getting-njt",
                        children: "GitHub\xa0repo’s\xa0README"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Crafted by",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                        href: "https://en.kachkaev.ru",
                        children: "Alexander Kachkaev"
                    }),
                    " ",
                    "using ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                        href: "https://nextjs.org",
                        children: "Next.js"
                    }),
                    ", hosted\xa0by\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* ExternalLink */.d, {
                        href: "https://vercel.com",
                        children: "Vercel"
                    }),
                    "\xa0\uD83D\uDC9A"
                ]
            })
        ]
    });
};
/* harmony default export */ var index_page = (Page);


/***/ }),

/***/ 9953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PageMetadata; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* provided dependency */ var process = __webpack_require__(3454);



const Head = (next_head_js__WEBPACK_IMPORTED_MODULE_1___default());
const getBaseUrl = ()=>{
    var _VERCEL_URL, ref;
    const hostname = (ref = (_VERCEL_URL = process.env.VERCEL_URL) !== null && _VERCEL_URL !== void 0 ? _VERCEL_URL : process.env.HOSTNAME) !== null && ref !== void 0 ? ref : "njt.vercel.app";
    const protocol = hostname.split(":")[0] === "localhost" ? "http" : "https";
    return "".concat(protocol, "://").concat(hostname);
};
const PageMetadata = (param)=>{
    let { title ="njt (npm jump to)" , description ="a quick navigation tool for npm packages"  } = param;
    const baseUrl = getBaseUrl();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Head, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl, "/og-image.png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image",
                content: "".concat(baseUrl, "/og-image.png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "vk:image",
                content: "".concat(baseUrl, "/og-image.png")
            })
        ]
    });
};


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(9208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);